export default {"src":"/_next/static/media/graduation.aab4a606.svg","height":304,"width":811};